import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-zorg-huis',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconZorgHuis {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M0 23.87h5.3V33.9H0zm31.15 6.47-11 .67-3.96-1.19.59-1.75 3.88 1.15 3.75-.3c-.01-.1-.34-2.61-3.69-3.5l-6.64-1.9-6.68.96v8.47l12.74 3.06 15.85-3.15s0-2.52-4.85-2.52Z"/>
  <path d="m7.61 14.35 1.92-1.59.04 9.55 4.16-.62c.24-.04.49-.02.72.06l7.22 2.17c3.43.95 4.5 3.18 4.69 4.63l4.38-.2V12.82l2.13 1.74 2.07-2.37-4.24-3.6V3.81h-3.18v2.22L20.11 0 5.52 12.08l2.09 2.26Zm9.34-2.52h6.35v5.01h-6.35z"/>
</svg>

    );
  }
}
